<script>
  import {getContext, createEventDispatcher} from 'svelte';
  import {map} from 'rxjs/operators';
  import {stringify} from 'query-string';
  import {goto} from '@sapper/app';
  import {mc} from '@/core';
  import {LINKS, IMAGES, PATHS, IMAGES_NEWS} from '@/const';
  import {MENU_ICONS2} from '../../const';
  import {fullImageUrlFun} from '@/helper/url';
  import {accountApi} from '@/api';
  import {isLogin$, lang$, fixLink$, userInfo$} from '@/store';
  import {logout$, userStatus$} from '@/streams/auth';
  import {languages$} from '@/streams/languages';
  import Button from '@/widgets/Button.svelte';
  import {getP2PTradeDefaultUrlLocal} from '@/modules/buy-crypto/fiat/components/util';
  import {promotions$, stickyPromotions$} from '@/modules/header/stream';
  import {web3ModuleState$} from '@/modules/web3/stream';
  import {isSupportLending$} from '@/streams/lending/state';
  import lang from '../../Header.lang';

  export let modalUI = false;

  const LG = getContext('LG');
  const fullImageUrl = fullImageUrlFun();
  const dispatch = createEventDispatcher();

  const mobileLanguages$ = languages$.pipe(
    map((list) =>
      list.reduce((pre, cur) => {
        pre[cur.value] = cur.text;
        return pre;
      }, {})
    )
  );

  let curIndex = 2;
  let isDropDown = true;
  let target = process.browser && location.origin + location.pathname;

  $: menuItems = createMenuItems(LG, $fixLink$, $lang$, $isLogin$, $stickyPromotions$, $promotions$, $mobileLanguages$, {
    web3ModuleState: $web3ModuleState$,
    isSupportLending: $isSupportLending$,
  });

  function createMenuItems(LG, fixLink, language, isLogin, stickyPromotions, promotions, languages, {web3ModuleState, isSupportLending}) {
    return [
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'Buy Crypto',
        title: LG(lang.BuyCrypto),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: LG(lang.BuyCryptoP2PMarketplace),
            link: getP2PTradeDefaultUrlLocal(isLogin, fixLink),
          },
          {
            type: 'Link',
            title: LG(lang.BuyCryptoWith),
            link: fixLink(isLogin ? PATHS.BUY_CRYPTO_PLACE_ORDER.pathname : PATHS.BUY_CRYPTO.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.BuyCryptoWithBank),
            link: fixLink(PATHS.OTC_LEGEND_TRADING.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.CreditDebitCards),
            link: fixLink(PATHS.BUY_CRYPTO_CARD_PLACE_ORDER.pathname),
          },
        ],
      },
      {
        hasChildren: 0,
        hasBorder: 0,
        isShow: true,
        tab: 'Markets',
        title: LG(lang.Markets),
        link: fixLink(PATHS.MARKETS.pathname),
        tag: '',
        children: [],
      },
      {
        hasChildren: 2,
        hasBorder: 0,
        isShow: true,
        tab: 'Contract',
        title: LG(lang.Contract),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: `USDⓈ-M ${LG(lang.Perpetual)}`,
            link: LINKS.PHEMEX_CONTRACT_TRADE_USDS,
          },
          {
            type: 'Link',
            title: `COIN-M ${LG(lang.Perpetual)}`,
            link: LINKS.PHEMEX_CONTRACT_INVERSE_TRADE,
          },
          {
            type: 'Link',
            title: LG(lang.CopyTrade),
            link: $fixLink$(PATHS.COPY_TRADING_LIST.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.Leaderboard),
            link: $fixLink$(PATHS.CONTRACT_LEADERBOARD.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.VipPortal),
            link: $fixLink$(PATHS.VIP_PORTAL.pathname),
          },
        ],
      },
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'Spot',
        title: LG(lang.Spot),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: LG(lang.SpotTrading),
            link: LINKS.PHEMEX_SPOT_TRADE,
          },
          {
            type: 'Link',
            title: LG(lang.Convert),
            link: fixLink(PATHS.CRYPTO_CONVERTER.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.Launchpad),
            link: fixLink(PATHS.LAUNCHPAD.pathname),
          },
        ],
      },
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'Earn',
        title: LG(lang.EarnMain),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: LG(lang.EarnCrypto),
            link: fixLink(PATHS.EARN_HOME.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.Savings),
            link: fixLink(PATHS.EARN.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.Launchpool),
            link: fixLink(PATHS.LAUNCHPOOL.pathname),
          },
        ],
      },
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'Web3',
        title: LG(lang.Web3),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: LG(lang.SocialTrade),
            link: fixLink(PATHS.WEB3_SOCIAL_TRADE_EXPLORE_GROUPS.pathname),
          },{
            type: 'Link',
            title: LG(lang.Web3PTStaking),
            link: fixLink(PATHS.WEB3_STAKE.pathname),
            hidden: !web3ModuleState
          },
          {
            type: 'Link',
            title: LG(lang.Phemexia),
            link: fixLink(PATHS.PHEMEXIA.pathname),
          },{
            type: 'Link',
            title: LG(lang.Web3SoulPass),
            link: fixLink(PATHS.WEB3_SOUL_PASS.pathname),
            hidden: !web3ModuleState
          },{
            type: 'Link',
            title: LG(lang.Web3Token),
            link: fixLink(PATHS.WEB3_EQUITY_BENEFITS.pathname),
            hidden: !web3ModuleState
          },
          {
            type: 'Link',
            title: LG(lang.Web3LendingProtocol),
            link: fixLink(PATHS.WEB3_LENDING_MARKET.pathname),
            hidden: !isSupportLending
          }
        ].filter((r)=> !r.hidden),
      },
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'Learn',
        title: LG(lang.Learn),
        link: '',
        tag: '',
        children: [
          {
            type: 'Link',
            title: LG(lang.Academy),
            link: fixLink(LINKS.PHEMEX_ACADEMY, 'CMS'),
          },
          {
            type: 'Link',
            title: LG(lang.LearnAndEarn),
            link: fixLink(PATHS.LEARN_CRYPTO.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.HelpCenter),
            link: fixLink(LINKS.PHEMEX_HELP_CENTER, 'CMS'),
          },
          {
            type: 'Link',
            title: LG(lang.Blog),
            link: fixLink(LINKS.PHEMEX_BLOG, 'CMS'),
          },
          {
            type: 'Link',
            title: LG(lang.StudentFoundation),
            link: fixLink(PATHS.STUDENT_FOUNDATION.pathname),
          },
          {
            type: 'Link',
            title: LG(lang.SimulatedTrading),
            link: LINKS.MOCK_TRADE,
          },
        ],
      },
      {
        hasChildren: 1,
        hasBorder: 1,
        isShow: true,
        tab: 'Promotions',
        title: LG(lang.Promotions),
        link: '',
        children: promotions,
      },
      {
        hasChildren: 0,
        hasBorder: 0,
        isShow: true,
        tab: stickyPromotions.title,
        title: stickyPromotions.title,
        link: stickyPromotions.link,
        img: stickyPromotions.cornerIcon && stickyPromotions.fullCornerIcon,
        tag: '',
        children: [],
      },
      {
        hasChildren: 0,
        hasBorder: 0,
        isShow: language === 'tr',
        tab: 'PhemexTR',
        title: 'PhemexTR',
        link: LINKS.PHEMEX_TR,
        tag: '',
        children: [],
      },
      {
        hasChildren: 1,
        hasBorder: 0,
        isShow: true,
        tab: 'lang',
        title: languages[language],
        link: '',
        img: "https://img.phemex.com/v1/a3504b73-da04-416b-9771-d6a662b062a4/language.svg",
        tag: '',
        children: createLanguageItems(languages, language),
      },
    ];
  }

  function handleClickLiFun(index) {
    return function () {
      if (curIndex === index) {
        isDropDown = false;
        curIndex = -1;
        return;
      }

      curIndex = index;
      isDropDown = true;
    };
  }

  function createLanguageItems(LANGUAGES, lang) {
    return Object.keys(LANGUAGES)
      .filter((o) => o !== lang)
      .reduce(
        (p, c) => [
          ...p,
          {
            type: 'Action',
            link: c,
            title: LANGUAGES[c],
            action() {
              if ($userStatus$ === 'Login') {
                updateProfile({lang: c});
                return;
              }
              lang$.set(c);
              dispatch('switch-lang');
            },
          },
        ],
        []
      );
  }

  function handleClickLogout(e) {
    e.preventDefault();
    logout$.next({manual: true});
  }

  function handleClickClose() {
    dispatch('handleClickClose');
  }

  async function updateProfile(params) {
    const {data, error} = await accountApi.updateProfile(params);
    if (data) {
      userInfo$.next(data);
      const {lang} = params;
      if (lang) {
        lang$.set(lang);
        dispatch('switch-lang');
      }
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }

  function handleClickRegister() {
    if (modalUI) {
      mc.send('modal-register', 'startRegister');
    } else {
      const target = location.origin + location.pathname + location.search;
      goto($fixLink$(PATHS.REGISTER.pathname) + '?' + stringify({target, action: 'Target'}));
    }
  }
</script>

<style>
  .wrap {
    height: 100%;
    overflow-y: scroll;
  }
  .logo {
    width: 80px;
    height: 100%;
  }
  .c-gray {
    color: #888B94;
  }
  .avatar {
    border-radius: 50%;
    width: 36px;
    height: 36px;
  }
  .arrow {
    transform: rotate(-90deg);
  }
  .w180 {
    width: 180px;
  }
  .close {
    font-size: 12px;
    color: #bfbfc1;
  }
  .login {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 20px 20px 40px;
    border-radius: 0;
    background: #0a0f1b;
  }
  .menu_div {
    margin-top: 20px;
    border-radius: 2px;
    width: 100%;
  }
  .animation {
    transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }
  .title {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 500;
    color: var(--TW);
  }
  li {
    line-height: 40px;
  }
  li a {
    -webkit-tap-highlight-color: #00000000;
    display: inline-block;
    width: 100%;
    color: #aaa;
  }
  .b-b {
    border-bottom: solid 1px #303339;
  }
  .children {
    padding-left: 30px;
    height: 0;
  }
  .children-auto-height {
    height: auto;
  }
  .wrap :global(.btn) {
    display: inline-block;
    padding: 0 14px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background-color: #0345f5;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    border-width: 0;
    border-radius: 24px;
  }
  .wrap :global(.account) {
    border: 1px solid #888b94;
    background: transparent;
    color: #fff;
  }
  .wrap :global(.btn-login) {
    background: transparent;
    border: 1px solid #888B94;
    font-size: 14px;
    font-weight: 700;
  }
  .wrap .btn-group :global(.btn) {
    height: 48px !important;
    line-height: 48px !important;
  }
  .wrap .btn-group :global(.btn-signup) {
    margin-left: 0 !important;
  }
  @media screen and (max-width: 640px) {
    li a {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .login :global(a:last-child) {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>

<div class="wrap">
  <div class="df jcsb aic mb16 ph16">
    <a href={$fixLink$(PATHS.HOME.pathname)}>
      <img class="logo" alt="Logo" src={IMAGES.LOGO_LIGHT} />
    </a>
    <div>
      {#if !$isLogin$}
        <a class="btn ph12 ga" href="javascript:;" on:click={handleClickRegister}>
          <span>{LG(lang.SignUp)}</span>
        </a>
      {/if}
      <i class="iconfont close cp ml16" on:click={handleClickClose}>&#xe65e;</i>
    </div>
  </div>
  <div class="df fdc ph16">
    {#if $isLogin$}
      <a class="df aic ovh" href={$fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname)}>
        <div class="avatar ovh">
          <img class="dib wp100 hp100" src={fullImageUrl($userInfo$.avatar)} alt="avatar" />
        </div>
        <div class="df jcsb aic f1 ml10 ovh">
          <div class="w180 f18 fw3 TW ooo">{$userInfo$.nickName}</div>
          <i class="iconfont arrow TW">&#xe623;</i>
        </div>
      </a>
      <div class=" df jcsb mt10">
        <Button class="btn f1" type="primary" size="small" href={$fixLink$(PATHS.ASSETS_OVERVIEW.pathname)}>{LG(lang.Assets)}</Button>
        <Button class="btn account ml16 f1" type="common" size="small" href={$fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname)}>{LG(lang.Account)}</Button>
      </div>
    {/if}
  </div>
  <ul class="menu_div">
    {#each menuItems as item, index}
      {#if item.title && item.isShow}
        <li class:b-b={item.hasBorder}>
          <a href={item.hasChildren ? 'javascript:void(0);' : item.link}>
            <div class="df aic jcsb ph16" on:click={handleClickLiFun(index)}>
              <div class="df aic">
                {#if item.icon}
                  <i class="iconfont T3">{@html item.icon}</i>
                {:else if item.img}
                  <img width="20" height="20" src={item.img} alt="" />
                {/if}
                <div>
                  <span class="title">{item.title}</span>
                  {#if item.tag}<img class="ml4" src={item.tag} alt="" />{/if}
                </div>
              </div>
              {#if item.hasChildren}<i class="iconfont TW" class:animation={curIndex === index && isDropDown}>&#xe65b;</i>{/if}
            </div>
          </a>
          {#if curIndex === index && isDropDown}
            <ul class="children" class:children-auto-height={curIndex === index && isDropDown}>
              {#each item.children as child}
                <li class="ph10 ooo TW">
                  {#if child.link && child.type !== 'Action'}
                    <a href={child.link}>{child.title}</a>
                  {:else}
                    <span on:click={child.action}>{child.title}</span>
                  {/if}
                </li>
              {/each}
            </ul>
          {/if}
        </li>
      {/if}
    {/each}
    {#if $isLogin$}
      <li class="df aic ph16" on:click={handleClickLogout}><img width="20" height="20" src="https://img.phemex.com/v1/59153781-de71-4af7-90bf-605ab268428a/active.svg" alt="" /> <span class="title">{LG(lang.LogOut)}</span></li>
    {/if}
  </ul>
  {#if !$isLogin$}
    <div class="login df fdc btn-group">
      <Button class="btn btn-login f1" type="common" size="small" href={$fixLink$(PATHS.LOGIN.pathname) + '?' + stringify({target})}>{LG(lang.LogIn)}</Button>
      <Button class="btn f1 mt16 btn-signup" type="primary" size="small" href="javascript:;" on:click={handleClickRegister}>{LG(lang.SignUp)}</Button>
    </div>
  {/if}
</div>
